function getCatalogSlug() {
    if ($('meta[property="catalog_slug"]').length > 0) {
        return $('meta[property="catalog_slug"]').attr('content');
    }

    return '';
}

function Product(settings) {
    this.wrapper = settings.wrapper || undefined;

    this.isProductPage = settings.isProductPage || false;
    this.id = settings.id || undefined;
    this.price = settings.price || undefined;
    this.count = settings.count || undefined;

    this.endpointAddToCart = settings.endpointAddToCart || undefined;
    this.endpointVariationsLoad = settings.endpointVariationsLoad || undefined;
    this.variationValueSelector = settings.variationValueSelector || undefined;
    this.variationExactMatchSelector = settings.variationExactMatchSelector || undefined;
    this.variationSelector = settings.variationSelector || undefined;
    this.useLegacyVariationLogic = settings.useLegacyVariationLogic || false;
    this.variations = settings.variations || undefined;

    this.inputPrice = settings.inputPrice || undefined;
    this.inputCount = settings.inputCount || undefined;

    this.textTitleWrapper = settings.textTitleWrapper || undefined;
    this.textPriceWrapper = settings.textPriceWrapper || undefined;

    this.btnCart = settings.btnCart || undefined;
    this.variationRequest = null;

    this.lastVariationResponse = null;

    this.binding();

    if (!this.useLegacyVariationLogic) {
        var variationsHolder = document.getElementById('variations-holder');
        if (variationsHolder && variationsHolder.getAttribute('data-load-on-init') === '1') {
            this.loadVariationState({});
        }
    }
}

Product.prototype.getCurrentVariationData = function() {
    if (this.useLegacyVariationLogic || !this.lastVariationResponse || !this.lastVariationResponse.selected_options) {
        return [];
    }

    var selectedOptions = this.lastVariationResponse.selected_options;
    var result = [];

    $('#variations-data-holder .variation-wrapper').each(function() {
        var code = $(this).find('.variation-selector').attr('name');
        if (code && selectedOptions.hasOwnProperty(code)) {
            result.push({
                code: code,
                name: $(this).find('label').text().replace(/:$/, '').trim() || code,
                value: String(selectedOptions[code])
            });
        }
    });

    return result;
};

Product.prototype.getCount = function() {
    let that = this;
    let count = 0;

    if (that.inputCount !== undefined) {
        count = parseInt($(that.inputCount).val());
    } else if (that.count !== undefined) {
        count = that.count;
    }

    return count;
};

Product.prototype.hasVariationSelectors = function() {
    return !!(this.variationSelector && $(this.variationSelector).length > 0);
};

Product.prototype.isExactVariationSelected = function() {
    if (!this.hasVariationSelectors()) {
        return true;
    }

    if (!this.variationExactMatchSelector) {
        return false;
    }

    return $(this.variationExactMatchSelector).val() === '1';
};

Product.prototype.getVariationCode = function() {
    if (!this.variationValueSelector) {
        return '';
    }

    return $(this.variationValueSelector).val() || '';
};

Product.prototype.getCurrentVariations = function() {
    let that = this;
    let variations = that.useLegacyVariationLogic ? [] : {};

    if (that.variationSelector !== undefined) {
        $(that.variationSelector).each(function() {
            let code = $(this).attr('name');
            let value = $(this).val();

            if (that.useLegacyVariationLogic) {
                if (value === '#') {
                    value = null;
                }
                if (code !== undefined && value !== undefined && value !== '') {
                    variations.push({
                        key: code,
                        value: value
                    });
                }
            } else if (code !== undefined && value !== undefined && value !== null && value !== '') {
                variations[code] = value;
            }
        });
    }

    return variations;
};

Product.prototype.parseVariationHash = function() {
    let hash = window.location.hash.replace(/^#/, '');

    if (!hash || hash === 'toVariation') {
        return {};
    }

    return hash.split('&').reduce(function(result, item) {
        if (!item.length) {
            return result;
        }

        let parts = item.split('=');
        let key = decodeURIComponent(parts[0] || '');
        let value = decodeURIComponent(parts[1] || '');

        if (key && value) {
            result[key] = value;
        }

        return result;
    }, {});
};

Product.prototype.setVariationHash = function(selectedOptions) {
    let hash = $.param(selectedOptions || {});

    if (hash) {
        window.location.hash = hash;
        return;
    }

    if (window.history && window.history.replaceState) {
        window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    } else {
        window.location.hash = '';
    }
};

Product.prototype.toggleVariationSelectors = function(isDisabled) {
    let selectors = $(this.variationSelector || '');

    selectors.prop('disabled', isDisabled);

    if (selectors.length > 0) {
        selectors.selectpicker('refresh');
    }

    let selectPickers = selectors.closest('.bootstrap-select');
    selectPickers.toggleClass('disabled', isDisabled);
    $('button.dropdown-toggle', selectPickers)
        .prop('disabled', isDisabled)
        .attr('aria-disabled', isDisabled ? 'true' : 'false');

    $('#variations-holder')
        .toggleClass('disabled', isDisabled)
        .toggleClass('variation-loading', isDisabled);
};

Product.prototype.renderVariationState = function(data) {
    if (typeof data.render !== 'string' || !data.render.length) {
        return;
    }

    this.lastVariationResponse = data;

    $('#variations-data-holder').replaceWith(data.render);

    if (typeof window.initProductVariationSelectors === 'function') {
        window.initProductVariationSelectors();
    }

    if (data.is_exact_match) {
        $(this.variationExactMatchSelector).val('1');
        $(this.variationValueSelector).val(
            data.selected_variant && data.selected_variant.product_id
                ? String(data.selected_variant.product_id)
                : ''
        );
        this.setVariationHash({});
        return;
    }

    $(this.variationExactMatchSelector).val('0');
    $(this.variationValueSelector).val('');
    this.setVariationHash(data.selected_options || {});
};

Product.prototype.loadVariationState = function(selectedOptions, changedField) {
    let that = this;

    if (!that.endpointVariationsLoad) {
        return;
    }

    if (that.variationRequest && typeof that.variationRequest.abort === 'function') {
        that.variationRequest.abort();
    }

    let requestData = {
        variation: selectedOptions || {},
        catalog_slug: getCatalogSlug()
    };
    if (changedField) {
        requestData.changed_field = changedField;
    }

    that.toggleVariationSelectors(true);
    that.variationRequest = $.ajax(that.endpointVariationsLoad, {
        dataType: 'json',
        data: requestData,
        success: function(data) {
            if (typeof data === 'object' && data && data.status === 'success' && data.link) {
                window.location.assign(data.link + '#toVariation');
                return;
            }

            that.renderVariationState(data || {});
            that.toggleVariationSelectors(false);
        },
        error: function(xhr, statusText) {
            if (statusText !== 'abort') {
                that.toggleVariationSelectors(false);
            }
        },
        complete: function() {
            that.variationRequest = null;
        }
    });
};

Product.prototype.restoreVariationSelectionFromHash = function() {
    let selectedOptions = this.parseVariationHash();

    if (!Object.keys(selectedOptions).length) {
        return;
    }

    this.loadVariationState(selectedOptions);
};

Product.prototype.searchCurrentVariationCodeInVariationList = function(currentVariations) {
    let that = this;
    let result = null;

    let isHasRow = function(currentVariation, variations) {
        let found = false;
        let code = currentVariation['key'];
        let value = currentVariation['value'];

        for (let i = 0; i < variations.length; i++) {
            if (code === variations[i]['code'] && value === variations[i]['value']) {
                found = true;
                break;
            }
        }

        return found;
    };

    let isEqu = function(currentVariations, variations) {
        if (currentVariations.length !== variations.length) {
            return false;
        }

        for (let i = 0; i < currentVariations.length; i++) {
            if (!isHasRow(currentVariations[i], variations)) {
                return false;
            }
        }

        return true;
    };

    if (that.variations !== undefined) {
        for (let variationCode in that.variations) {
            if (that.variations.hasOwnProperty(variationCode) && isEqu(currentVariations, that.variations[variationCode])) {
                result = variationCode;
            }
        }
    }

    return result;
};

Product.prototype.variationUrl = function(productSlug, variationUrlParams) {
    return '/product/' + productSlug + '/?' + variationUrlParams;
};

Product.prototype.generateVariationUrl = function(variationValue, foundVariation) {
    if (!variationValue || variationValue.hasOwnProperty('generated')) {
        return undefined;
    }

    let productSlug = String(variationValue['product_id']);
    let params = [];
    for (let i = 0; i < foundVariation.length; i++) {
        params.push('variation[' + foundVariation[i]['code'] + ']=' + foundVariation[i]['value']);
    }

    return this.variationUrl(productSlug, params.join('&'));
};

Product.prototype.findVariationsAvalibaleValues = function(variationName, variationValue) {
    let that = this;
    let avalibaleValues = {};
    let variations = that.variations || {};

    for (let variationCode in variations) {
        if (!variations.hasOwnProperty(variationCode)) {
            continue;
        }

        let values = {};
        let isFind = false;
        variations[variationCode].forEach(function(data) {
            let code = data.code || undefined;
            let value = data.value || undefined;

            if (code === variationName && value === variationValue) {
                isFind = true;
            }

            if (!values.hasOwnProperty(code)) {
                values[code] = [];
            }

            values[code].push(value);
        });

        if (isFind) {
            for (let code in values) {
                if (!avalibaleValues.hasOwnProperty(code)) {
                    avalibaleValues[code] = [];
                }
                avalibaleValues[code] = avalibaleValues[code].concat(values[code]);
            }
        }
    }

    return avalibaleValues;
};

Product.prototype.binding = function() {
    let that = this;

    $(that.btnCart).off('click.productAddToCart').on('click.productAddToCart', function(e) {
        e.preventDefault();

        if (!that.id) {
            return false;
        }

        if (!that.useLegacyVariationLogic && !that.isExactVariationSelected()) {
            let event = new CustomEvent('INVALID_VARIATION', {
                detail: {
                    id: that.id,
                    variationCode: that.getVariationCode()
                }
            });
            document.dispatchEvent(event);
            return false;
        }

        let count = that.getCount();
        if (count <= 0) {
            return false;
        }

        if (that.endpointAddToCart !== undefined) {
            let variationData = [];
            if (that.useLegacyVariationLogic) {
                let variationCode = that.getVariationCode();
                variationData = (that.variations && that.variations[variationCode]) || [];

                let validVariation = true;
                for (let i = 0; i < variationData.length; i++) {
                    let data = variationData[i];
                    let code = data['code'] || undefined;
                    let value = data['value'] || undefined;
                    let fieldValue = $('.variation-selector[name="' + code + '"]').val();

                    if (value != fieldValue) {
                        validVariation = false;
                        break;
                    }
                }

                if (!validVariation) {
                    let legacyInvalidEvent = new CustomEvent('INVALID_VARIATION', {
                        detail: {
                            id: that.id,
                            variationCode: variationCode,
                            variationData: variationData
                        }
                    });
                    document.dispatchEvent(legacyInvalidEvent);
                    return false;
                }
            } else {
                variationData = that.getCurrentVariationData();
            }

            let data = {
                'id': that.id,
                'amount': count,
                'variation_code': that.getVariationCode(),
                'variation_data': variationData,
                'catalog_slug': getCatalogSlug()
            };

            axaj_post_request(that.endpointAddToCart, data, function(response) {
                $(document).trigger('PRODUCT_ADD_TO_CART', [response, that.id]);

                let event = new CustomEvent('PRODUCT_ADDED_TO_CART', {
                    detail: {
                        id: that.id,
                        response: response
                    }
                });
                document.dispatchEvent(event);
            });
        }
    });

    $(document).off('change.productVariations', that.variationSelector).on('change.productVariations', that.variationSelector, function(e) {
        if (!$(this).is('select') || $(this).is('.disabled') || $(this).closest('.disabled').length) {
            return;
        }

        if (that.useLegacyVariationLogic) {
            let currentVariations = that.getCurrentVariations();
            let foundVariation = false;
            let foundVariationCode = that.searchCurrentVariationCodeInVariationList(currentVariations);

            if (foundVariationCode && that.variations && that.variations.hasOwnProperty(foundVariationCode)) {
                foundVariation = that.variations[foundVariationCode];
            }

            if (foundVariation) {
                let variationName = $(this).attr('name');
                let variationValue = null;
                for (let i = 0; i < foundVariation.length; i++) {
                    if (variationName === foundVariation[i]['code']) {
                        variationValue = foundVariation[i];
                    }
                }
                if (variationValue != null) {
                    let event = new CustomEvent('GOT_VALID_VARIATION_URL', {
                        detail: {
                            url: that.generateVariationUrl(variationValue, foundVariation),
                            variation_code: foundVariationCode,
                            catalog_slug: getCatalogSlug(),
                            foundVariation: foundVariation
                        }
                    });
                    document.dispatchEvent(event);
                } else {
                    document.dispatchEvent(new Event('NOT_FOUND_VARIATION'));
                }
            } else {
                document.dispatchEvent(new CustomEvent('NOT_FOUND_VARIATION', {
                    detail: {
                        field: this,
                        value: e.target.value
                    }
                }));
            }
            return;
        }

        that.loadVariationState(that.getCurrentVariations(), $(this).attr('name'));
    });

    if (that.useLegacyVariationLogic) {
        $(document).off('GOT_VALID_VARIATION_URL.product').on('GOT_VALID_VARIATION_URL.product', function(e) {
            let data = e.originalEvent ? e.originalEvent.detail : e.detail;
            if (!data) {
                return false;
            }

            if (that.variationValueSelector && data.hasOwnProperty('variation_code')) {
                $(that.variationValueSelector).val(data['variation_code']);
            }

            $('#variations-holder').addClass('disabled');
            if (that.variationSelector) {
                $(that.variationSelector).attr('disabled', true).selectpicker('refresh');
            }

            if (data.hasOwnProperty('url') && data.url) {
                $.ajax('/ajax' + data.url, {
                    dataType: 'json',
                    success: function(data) {
                        if (typeof data === 'object' && data && data.status === 'success' && data.link) {
                            window.location.assign(data.link + '#toVariation');
                            return;
                        }

                        $('#product-data-holder').html(data.render);
                        if (that.variationSelector) {
                            $(that.variationSelector).attr('disabled', false).selectpicker('refresh');
                        }
                        if (window.initPageProduct) {
                            window.initPageProduct();
                        }
                        if ($.fn.inputSpinner) {
                            $("#product-data-holder input[type='number']").inputSpinner({
                                decrementButton: '<i class="icon-minus"></i>',
                                incrementButton: '<i class="icon-plus"></i>',
                                groupClass: 'input-spinner',
                                buttonsClass: 'btn-spinner',
                                buttonsWidth: '26px'
                            });
                        }
                        if (window.initCarousels) {
                            window.initCarousels($('#product-data-holder'));
                        }
                        document.dispatchEvent(new CustomEvent('PRODUCT_VARIATION_RELOADED', { detail: data.product.id }));
                    },
                    error: function() {
                        $('#variations-holder').removeClass('disabled');
                    }
                });
            } else if (that.variationSelector) {
                $(that.variationSelector).attr('disabled', false).selectpicker('refresh');
            }
        });

        $(document).off('NOT_FOUND_VARIATION.product').on('NOT_FOUND_VARIATION.product', function(e) {
            let eventData = e.originalEvent ? e.originalEvent.detail : e.detail;
            if (eventData === undefined) {
                return false;
            }

            let selectedVariationCode = $(eventData.field).attr('name') || undefined;
            let selectedVariationName = eventData.value || undefined;
            let avalibaleValues = that.findVariationsAvalibaleValues(selectedVariationCode, selectedVariationName);
            let selectedVariationId = $(eventData.field).attr('id') || undefined;
            let fields = $('.variation-selector');
            fields.each(function(i, element) {
                let id = $(element).attr('id');
                if (selectedVariationId != id) {
                    let selectedFieldValue = $(':selected', element).val();
                    let selectedFieldName = $(element).attr('name');
                    if (avalibaleValues.hasOwnProperty(selectedFieldName) && !avalibaleValues[selectedFieldName].includes(selectedFieldValue)) {
                        $(element).selectpicker('val', null);
                    }
                }
            });
        });
    }

    $(document).off('INVALID_VARIATION.product').on('INVALID_VARIATION.product', function(e) {
        let eventData = e.originalEvent ? e.originalEvent.detail : e.detail;
        if (eventData === undefined) {
            return false;
        }

        alert('Invalid data');
    });
};
